import React from 'react';
import { Panel, Glyphicon } from 'react-bootstrap';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import forEach from 'lodash/forEach';
import BSTableDateTimeEditor from '../../../../components/BSTableDateTimeEditor';
import Loader from '../../../../components/Loader';
import { formatDateTime } from '../../../../shared/utils/date';
import { I18N } from '../../../../constants';

const createDateEditor = (onUpdate, props) => (
    <BSTableDateTimeEditor onUpdate={onUpdate} {...props} />
);

const manualDateFormatter = cell => {
    return (
        <div style={{ cursor: 'pointer' }}>
            {formatDateTime(cell)}{' '}
            <Glyphicon
                glyph="glyphicon glyphicon-pencil"
                style={{ marginLeft: '3px' }}
                className={'pull-right'}
            />
        </div>
    );
};

const toastrOptions = {
    timeOut: 4000,
};

const dateValidator = value => {
    const response = {
        isValid: true,
        notification: { type: 'success', msg: '', title: '' },
    };

    if (value && !moment(value, 'YYYY-MM-DD HH:mm', true).isValid()) {
        response.isValid = false;
        toastr.error('Wrong date format', "Please use 'YYYY-MM-DD HH:mm'", toastrOptions);
    } else if (value && moment(value).isAfter(moment())) {
        response.isValid = false;
        toastr.error('Future date', "The date can't be in the future.", toastrOptions);
    }

    return response;
};

class StopsList extends React.Component {
    onCellEdit = (row, fieldName, value) => {
        const { run } = this.props;
        let data = {};
        let updatedWaypoints = [];

        forEach(run.wayPoints, w => {
            if (w.stopNumber === row.stopNumber) {
                if (fieldName === 'manualArrival') {
                    updatedWaypoints.push({
                        hasArrived: !(value === '' || !value),
                        manualArrival: moment(value).toISOString(),
                        manualDeparture: w.manualDeparture,
                        waypointStopNumber: w.stopNumber,
                    });
                }

                if (fieldName === 'manualDeparture') {
                    updatedWaypoints.push({
                        hasArrived: true,
                        manualArrival: w.manualArrival,
                        manualDeparture: moment(value).toISOString(),
                        waypointStopNumber: w.stopNumber,
                    });
                }
            }
        });

        data.runId = run.runId;
        data.waypoints = updatedWaypoints;

        this.props.onUpdateLocationManually(data);
    };

    render() {
        const { handleStopHover, handleStopsLeave, run } = this.props;
        const options = {
            onRowMouseOver: handleStopHover,
            onMouseLeave: handleStopsLeave,
            onCellEdit: this.onCellEdit,
        };

        const cellEditProps = {
            blurToSave: false,
            mode: 'click',
        };

        if (!run) {
            return <Loader />;
        }

        return (
            <Panel collapsible defaultExpanded header="Stops" style={{ height: 546 }}>
                {run &&
                    run.wayPoints &&
                    run.wayPoints.length === 0 && <p>No stops to display...</p>}
                {run &&
                    run.wayPoints &&
                    run.wayPoints.length > 0 && (
                        <BootstrapTable
                            data={run.wayPoints}
                            height="475px"
                            maxHeight="475px"
                            hover
                            scrollTop={'Top'}
                            remote={true}
                            options={options}
                            cellEdit={cellEditProps}
                        >
                            <TableHeaderColumn isKey dataField="stopNumber" width="50">
                                #
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="stopName" editable={false} width="200">
                                Stop name
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="stopCode" editable={false} width="120">
                                Stop code
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="stopPlantCode"
                                editable={false}
                                width="120"
                            >
                                Plant Code
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="stopDockCode"
                                editable={false}
                                width="120"
                            >
                                Dock Code
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="stopType"
                                dataFormat={stopType => I18N.STOP_TYPE[stopType]}
                                editable={false}
                                width="150"
                            >
                                Type
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="plannedArrival"
                                dataFormat={formatDateTime}
                                editable={false}
                                width="130"
                            >
                                Arrival
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="plannedDeparture"
                                dataFormat={formatDateTime}
                                editable={false}
                                width="130"
                            >
                                Departure
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="manualArrival"
                                dataFormat={manualDateFormatter}
                                editable={{ validator: dateValidator }}
                                customEditor={{ getElement: createDateEditor }}
                                width="230"
                            >
                                Manual arrival
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="manualDeparture"
                                dataFormat={manualDateFormatter}
                                editable={{ validator: dateValidator }}
                                customEditor={{ getElement: createDateEditor }}
                                width="230"
                            >
                                Manual departure
                            </TableHeaderColumn>
                        </BootstrapTable>
                    )}
            </Panel>
        );
    }
}

export default StopsList;
